import { render, staticRenderFns } from "./FiniquitoList.vue?vue&type=template&id=33748f64&lang=pug&"
import script from "./FiniquitoList.vue?vue&type=script&lang=js&"
export * from "./FiniquitoList.vue?vue&type=script&lang=js&"
import style0 from "./FiniquitoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FiniquitoList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {
  VCard,
})
